import { createSlice } from "@reduxjs/toolkit";

// Helper function to get cart from localStorage
const getCartFromStorage = () => {
  try {
    const cartData = localStorage.getItem("cart");
    if (cartData) {
      const parsed = JSON.parse(cartData);
      const now = Date.now();
      const fiveHours = 5 * 60 * 60 * 1000; // 5 hours in millise
      
      // Check if cart is older than 5 hours
      if (parsed.timestamp && (now - parsed.timestamp) > fiveHours) {
        localStorage.removeItem("cart");
        return { items: [], storeId: null };
      }
      
      return {
        items: parsed.items || [],
        storeId: parsed.storeId || null
      };
    }
    return { items: [], storeId: null };
  } catch (error) {
    console.error("Error loading cart from localStorage:", error);
    localStorage.removeItem("cart");
    return { items: [], storeId: null };
  }
};

// Helper function to save cart to localStorage
const saveCartToStorage = (cart, storeId) => {
  try {
    const cartData = {
      items: cart,
      storeId: storeId,
      timestamp: Date.now()
    };
    localStorage.setItem("cart", JSON.stringify(cartData));
  } catch (error) {
    console.error("Error saving cart to localStorage:", error);
  }
};

const initialCartData = getCartFromStorage();

export const cartSlice = createSlice({
  name: "cart",
  initialState: {
    cart: initialCartData.items,
    storeId: initialCartData.storeId,
    // categoryList : [],
    // menuList : [],
    // selectedCategory : "",
    // selectedMenuItem : {}
  },
  reducers: {
    addCart: (state, action) => {
      const { storeId, ...item } = action.payload;
      
      // If storeId is provided and different from current, clear cart first
      if (storeId && state.storeId && state.storeId !== storeId) {
        state.cart = [];
      }
      
      // Set the store ID
      if (storeId) {
        state.storeId = storeId;
      }
      
      const findIndex = state.cart.findIndex(
        (cartItem) => cartItem.id === item.id
      );
      if (findIndex !== -1) {
        state.cart[findIndex] = item;
      } else {
        state.cart.push(item);
      }
      // Save to localStorage after updating cart
      saveCartToStorage(state.cart, state.storeId);
    },
    increaseQty: (state, action) => {},
    dicreaseQty: (state, action) => {},
    removeOrder: (state, action) => {
      const findIndex = state.cart.findIndex(
        (item) => item.id === action.payload
      );
      if (findIndex !== -1) {
        state.cart.splice(findIndex, 1); // Removes the element at the found index
      }
      // Save to localStorage after updating cart
      saveCartToStorage(state.cart, state.storeId);
    },
    resetCart: (state) => {
      state.cart = [];
      state.storeId = null;
      localStorage.removeItem("cart");
    },
    clearCartOnOrder: (state) => {
      state.cart = [];
      state.storeId = null;
      localStorage.removeItem("cart");
    },
    validateCartStore: (state, action) => {
      const currentStoreId = action.payload;
      // If cart has items and store ID doesn't match current store, clear cart
      if (state.cart.length > 0 && state.storeId && state.storeId !== currentStoreId) {
        state.cart = [];
        state.storeId = null;
        localStorage.removeItem("cart");
      }
    },
  },
});
export const { addCart, removeOrder, resetCart, clearCartOnOrder, validateCartStore } = cartSlice.actions;
export default cartSlice.reducer;
